<section class="pc-section" style="margin-top: 5vh;">

  <!-- HEADER -->
  <div class="pc-header">
    <h2>Protección Civil</h2>
    <p>Recursos y herramientas para simulacros</p>
  </div>

  <!-- GRID -->
  <div class="pc-grid">

    <!-- CARD 1 -->
    <a class="pc-card" target="_blank"
      href="https://firebasestorage.googleapis.com/v0/b/autlan-51170.appspot.com/o/Transparencia%2FIPR67007G1Gu%C3%ADa_Pr%C3%A1ctica_de_simulacros_de_evacuaci%C3%B3n_de_inmuebles_2021.pdf?alt=media&token=457cec60-9a3e-4f68-b383-5a106098c167">

      <div class="pc-icon">
        <img src="https://firebasestorage.googleapis.com/v0/b/autlan-51170.appspot.com/o/Transparencia%2FIPR9714G1manual.png?alt=media&token=95ca2590-0ff0-4d82-95cd-b80665966ada">
      </div>

      <h3>Guía Práctica de Simulacros</h3>
      <span>Descargar PDF →</span>
    </a>

    <!-- CARD 2 -->
    <a class="pc-card" target="_blank"
      href="https://firebasestorage.googleapis.com/v0/b/autlan-51170.appspot.com/o/Transparencia%2FIPR67007G1INSTRUCCIONES_LLENADO_SIMULACRO_GABINETE_2025.pdf?alt=media&token=6d4ca52c-064b-437f-9433-acf1ad077f51">

      <div class="pc-icon">
        <img src="https://firebasestorage.googleapis.com/v0/b/autlan-51170.appspot.com/o/Transparencia%2FIPR9714G1instrucciones.png?alt=media&token=079f0db0-aabe-48e1-b683-f2968e8793f3">
      </div>

      <h3>Instrucciones Simulacro</h3>
      <span>Ver documento →</span>
    </a>

    <!-- CARD 3 -->
    <a class="pc-card" target="_blank"
      href="https://firebasestorage.googleapis.com/v0/b/autlan-51170.appspot.com/o/Transparencia%2FIPR67007G1SIMULACRO_DE_GABINETE_abril_2025.pdf?alt=media&token=a1e912ca-6075-4c7e-aaff-5615e86c41a9">

      <div class="pc-icon">
        <img src="https://firebasestorage.googleapis.com/v0/b/autlan-51170.appspot.com/o/Transparencia%2FIPR9714G1registro-en-linea.png?alt=media&token=15add0f3-1930-4887-8ddd-f37fadb5bec9">
      </div>

      <h3>Formulario de Simulacro</h3>
      <span>Abrir →</span>
    </a>

    <!-- CARD 4 -->
    <a class="pc-card" target="_blank"
      href="https://firebasestorage.googleapis.com/v0/b/autlan-51170.appspot.com/o/Transparencia%2FIPR67007G1CEDULA_PARA_EVALUAR_abril_2025.pdf?alt=media&token=8213f36b-be0a-4b1f-8757-0db87ba0095e">

      <div class="pc-icon">
        <img src="https://firebasestorage.googleapis.com/v0/b/autlan-51170.appspot.com/o/Transparencia%2FIPR9714G1documentos-oficiales.png?alt=media&token=30655384-e272-45eb-8810-a2df42d60167">
      </div>

      <h3>Cédula de Evaluación</h3>
      <span>Descargar →</span>
    </a>

  </div>

</section>
